export const SUGGESTED_ACTIONS_THRESHOLDS = {
    POSITIVE: {
        1: 3,
        2: 4,
        3: 5,
        4: 8,
        5: 10,
    },
};

export const IMPACT_BRIEF_COST_SAVINGS = 451; // from the doc references, 587 w/o pendo 136 w/
